import React from "react";
import { CardCurso } from "./CardCurso";

export const MenuCursos = ({
  isActive,
  cursosActuales,
  cursosFinalizados,
  cursosDisponibles,
}) => {
  if (isActive === "actuales") {
    return <CardCurso cursos={cursosActuales} cardTipo="actuales" />;
  } else if (isActive === "finalizados") {
    return <CardCurso cursos={cursosFinalizados} cardTipo="finalizados" />;
  } else if (isActive === "disponibles") {
    return <CardCurso cursos={cursosDisponibles} cardTipo="disponibles" />;
  }
};
